import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { Disclaimer } from 'src/app/models/disclaimer.model'
import { MainService } from 'src/app/services/main.service'

const profIndex = 0
const discIndex = 1
const fundContentIndex = 2
@Injectable({
  providedIn: 'root',
})
export class DisclaimersService {
  constructor(private readonly mainService: MainService) {}
  disclaimernModel = {} as Disclaimer

  getModelData(): Observable<Disclaimer> {
    return new Observable((subscriber) => {
      this.mainService
        .getDisclaimerObservable()
        .pipe(take(1))
        .subscribe((distObs) => {
          if (
            Object.keys(distObs).length !== 0 &&
            distObs[0] !== null &&
            distObs[0].name !== 'HTTPError'
          ) {
            this.disclaimernModel = {
              profile: distObs[profIndex].fundProfile,
              risk: distObs[discIndex],
              content: distObs[fundContentIndex],
            }
          }
          subscriber.next(this.disclaimernModel)
          subscriber.complete()
        })
    })
  }
}
